module.exports = __webpack_public_path__ + "img/clipboard-list-check.0257a443.svg";